import { render, staticRenderFns } from "./NameAndRoomBadge.vue?vue&type=template&id=5a490696&scoped=true&lang=pug&"
import script from "./NameAndRoomBadge.vue?vue&type=script&lang=js&"
export * from "./NameAndRoomBadge.vue?vue&type=script&lang=js&"
import style0 from "./NameAndRoomBadge.vue?vue&type=style&index=0&id=5a490696&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a490696",
  null
  
)

export default component.exports